class CollapseAllButton
  constructor: ->
    $(document).on 'click', '[data-collapse-all]', (e) ->
      el = $(e.currentTarget)
      hideElements(el)
      replace(el)
      triggerEvents(el)

  @create: (options) ->
    ###
    Required attributes:
      * target
    ###
    $('<button>')
      .attr('data-collapse-all', true)
      .text('Collapse All')
      .addClass('btn btn-sm btn-danger')
      .data('target', options.target)

  hideElements = (el) ->
    target = $(el.data('target'))
    target.find('[data-toggle="collapse"]:contains("Collapse")').click()

  replace = (el) ->
    target = $(el.data('target'))
    el.replaceWith ExpandAllButton.create(target: target)

  triggerEvents = (el) ->
    $(document).trigger
      type: 'collapse:collapsed'
      element: $(el.data('target'))

global.CollapseAllButton = CollapseAllButton
export default CollapseAllButton